<script lang="ts">
import { sanitizeRichTextHtml } from '$lib/utils/sanitise.js';
import { prepareHtmlLinks } from '$lib/utils/url.js';

interface Props {
    content?: string;
    hideBlock?: boolean;
}

let { content = '', hideBlock = false }: Props = $props();

let sanitisedContent = $derived(prepareHtmlLinks(sanitizeRichTextHtml(content)));
</script>

{#if !hideBlock}
    <div class="editorial-text builder-text">
    	{@html sanitisedContent}
    </div>
{/if}

<style lang="scss">
.editorial-text {
	margin-bottom: var(--layout-pagegrid-margin);
}
</style>
